import { render, staticRenderFns } from "./material_list.vue?vue&type=template&id=6b9778cd"
import script from "./material_list.vue?vue&type=script&lang=js"
export * from "./material_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9778cd')) {
      api.createRecord('6b9778cd', component.options)
    } else {
      api.reload('6b9778cd', component.options)
    }
    module.hot.accept("./material_list.vue?vue&type=template&id=6b9778cd", function () {
      api.rerender('6b9778cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/group_buying/ex_warehouse/form/components/material_list.vue"
export default component.exports